const TEMPLATE_NAME = 'REPORT_TYPE';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: newData,
        filter: {
          ...state.filter,
          data: [...state.loadedData, ...newData]
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
